const map = {
	"./brb.png": 8874,
	"./chl.png": 2551,
	"./col.png": 5962,
	"./cri.png": 3980,
	"./dom.png": 3680,
	"./ecu.png": 525,
	"./mex.png": 2566,
	"./per.png": 4418,
	"./tyt.png": 6064
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9033;